import type { Colors, DefaultTheme } from 'styled-components';
import { Direction } from '../../types/Direction';
import { setAlpha } from '../utils';
import { lightColors, mapLightTheme } from './LightTheme';

const colors: Colors = {
  primary: {
    lighten: '#6ec8fe',
    default: '#3cb5fd',
    dim: 'rgba(60,181,253,0.4)',
    mute: 'rgba(60,181,253,0.1)',
  },
  gray: {
    main: '#ffffff',

    '000': '#e6e6e7',
    '010': '#f2f2f3',
    '020': '#fafafa',
    '030': '#ebebeb',
    '040': '#dbdbdd',
    '050': '#d2d2d4',
    '060': '#c8c8ca',
    '070': '#bbbbbe',
    '080': '#9b9b9f',
    '090': '#696970',
    '100': '#1d1d28',
  },
  green: {
    lighten: '#3ca371',
    default: '#2E7E57',
    dim: 'rgba(46,126,87,0.4)',
    mute: 'rgba(46,126,87,0.1)',
  },
  red: {
    lighten: '#c74454',
    default: '#A63240',
    dim: 'rgba(166,50,64,0.4)',
    mute: 'rgba(166,50,64,0.1)',
  },
  yellow: {
    lighten: '#e3a71c',
    default: '#B68616',
    dim: 'rgba(182,134,22,0.4)',
    mute: 'rgba(182,134,22,0.1)',
  },
  orange: {
    lighten: '#ff6511',
    default: '#DD4E00',
    dim: 'rgba(221,78,0,0.4)',
    mute: 'rgba(221,78,0,0.1)',
  },

  purple: lightColors.purple,
  blue: lightColors.blue,

  white: {
    default: '#ffffff',
    dim: 'rgba(255,255,255,0.4)',
    mute: 'rgba(255,255,255,0.1)',
  },
  black: {
    default: '#000000',
    dim: 'rgba(0,0,0,0.4)',
    mute: 'rgba(0,0,0,0.1)',
  },
};

export const LightTDATheme: DefaultTheme = mapLightTheme(colors, {
  name: 'LightTDA',

  fontFamily: "'Geist', sans-serif;",
  fontUrl: 'https://fonts.googleapis.com/css2?family=Geist:wght@@300;400;500;600;700&display=swap',
  backgroundSidebarItemActive: colors.black.mute,
  backgroundSidebarItemHover: colors.black.mute,

  colorTextWarning: colors.yellow.dim,
  colorTextWarningSubtle: colors.yellow.dim,
  colorTextWarningMuted: colors.yellow.dim,

  borderRadiusContent: 3,
  spacingLayout: 8,

  borderColorChartGridLine: colors.gray['010'],
  borderColorChartAxis: colors.gray['010'],

  boxShadowContent: '0 2px 16px rgba(0, 0, 0, 0.05)',
  boxShadowHeader: '0 2px 16px rgba(0, 0, 0, 0.1)',

  backgroundVolumeLadderBidSpread: colors.gray['060'],
  backgroundVolumeLadderOfferSpread: colors.gray['060'],
  backgroundVolumeLadderTransparencyDirection: Direction.Desc,

  colorOrderStatusRejected: colors.red.lighten,

  colorTabHover: colors.gray['040'],

  backgroundPriorityButton: setAlpha(0.12, colors.gray['100']),
  backgroundPriorityButtonHover: setAlpha(0.18, colors.gray['100']),
  backgroundPriorityButtonFocus: setAlpha(0.18, colors.gray['100']),
  backgroundPriorityButtonActive: setAlpha(0.12, colors.gray['100']),
  backgroundPriorityButtonDisabled: setAlpha(0.08, colors.gray['100']),
});
